import {Box, Text, Tip} from 'grommet'
import { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'

interface Props extends PropsWithChildren<{}> {
  content: ReactNode
}

const TipDescription = styled.span`
  cursor: pointer;
`

export default function Tooltip({content, children}: Props) {
  return (
    <Tip
      content={(
        <Box align="center" pad={{left: 'xlarge', right: 'xlarge', top: 'medium', bottom: 'medium'}}>
          <Box background="dark-2" pad="small" round="xsmall" animation={[{type: 'fadeIn', size: 'small'}]}>
            <Text color="light-1">{content}</Text>
          </Box>
        </Box>
      )}
      plain
    >
      <TipDescription>{children}</TipDescription>
    </Tip>
  )
}
